// extracted by mini-css-extract-plugin
export default {"h":"style_h__D0n60","duo":"style_duo__GK5qj"};